

import React, { useEffect, useState } from "react"; 
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import Button from "../../components/button"; 

TopInstitute.propTypes = {};

function TopInstitute(props) {
    const token = localStorage.getItem('token')
    const [dataBlock] = useState({
        title: "Top Institute",
        text: "Showing Institute based on reviews and recent job openings",
    });

    const { data } = props;
    const { className } = props;


    const [institutes, setInstitutes] = useState([]);

    const fetchInstituteData = async () => {
        try {
            const response = await axios.post("/Institute/GetAll", {
                pageNumber: 1,
                pageSize: 10,
            });
            console.log("Institute:", response.data.responseData.instituteProfiles);
            setInstitutes(response.data.responseData.instituteProfiles);
        } catch (error) {
            console.error("Error Institute:", error);
        }
    };

    useEffect(() => {
        fetchInstituteData();
    }, []);
    console.log("institutes", institutes);

    return (

        <>
        {institutes.length === 0 ? "" : (

            <section className={className}>
                <div className="container">
                    <div className="wd-employer">
                        <div className="tf-title mt-4">
                            <div className="group-title">
                                <h1>{dataBlock.title}</h1>
                                <p>{dataBlock.text}</p>
                            </div> 
                            <Link to={"/Institute"} style={{ color: '#feaa00' }} className="f-600">
                                All Institute<Button className='mt-2' link="/Institute" />
                            </Link>
                        </div>
                        <div className="row wow fadeInUp"> 

                            {institutes.slice(0, 4).map((institute, idx) => (
                                <div key={idx.id} className="col-xl-3 col-lg-6  col-md-12 col-sm-6">
                                    <div className="employer-block All-Card-Employer"> 
                                        <div className="inner-box mt-0">
                                            <div className="logo-company logo-company-topinstitute"> 
                                                <img src={institute.logoImage} />
                                            </div>
                                            <div className="box-content"> 
                                                <h3 className="mb-0">
                                                    {token === null ? institute.name : <Link to="/Institute">{institute.name}</Link>}
                                                    
                                                </h3>
                                                <p className="info">
                                                    {institute.cityName === null ? '' : <>
                                                        <span className="icon-map-pin me-2"></span>{institute.cityName}</>}

                                                </p>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </section>
            )}

        </>
    );
}

export default TopInstitute;
